import { useEffect } from 'react'

import { wchatRightOffset } from '@/_vars'
import { useDelayedAction } from '@/lib/react-hooks/useDelayedAction'

interface IParams {
	containerRef: HTMLDivElement | null
	trigger: boolean
}

export const useChatPosition = ({ containerRef, trigger }: IParams) => {
	const executeAction = useDelayedAction()
	useEffect(() => {
		const root: HTMLElement = document.querySelector(':root')!

		if (!trigger || !root) {
			return undefined
		}

		executeAction(() => {
			const containerWidth = containerRef?.getBoundingClientRect().width || 0
			root.style.setProperty('--wchat-right', containerWidth + wchatRightOffset + 'px')
		})

		return () => {
			root.style.setProperty('--wchat-right', `${wchatRightOffset}px`)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [trigger, containerRef, executeAction])

	return null
}
